import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ComponentsService {

  constructor(private http:HttpClient) { }

  GetNewAppointmentsAndReferralCount() {
    return this.http.get(environment.configUrl + 'Dashboard/GetNewAppointmentsAndReferralCount?CurrentDate=' + new Date());
  }

  InsertErrorLog(){
    return this.http.get(environment.configUrl + 'EmailTemplate/InsertErrorLog?CurrentDate=' + new Date());
  }
}
